import { useQuery } from '@tanstack/react-query';
import { featureFlagsApi } from '@/api/endpoints/featureFlags';
import { queryKeys } from '@/lib/queryKeys';
import { useAuthStore } from '@/stores/authStore';

export function useFeatureFlag(key: string) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { data: flags, isLoading, isError, refetch } = useQuery({
    queryKey: queryKeys.featureFlags.resolved(),
    queryFn: async () => {
      const { data } = await featureFlagsApi.getResolved();
      return data;
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  });

  const flag = flags?.find((f: { key: string }) => f.key === key);
  return {
    enabled: flag?.isEnabled ?? false,
    isLoading: isAuthenticated ? isLoading : false,
    isError: isAuthenticated ? isError : false,
    refetch,
  };
}
